<template>
  <div>
    <v-navigation-drawer fixed v-model="drawer" :class="$root.sidebarBg" class="darken-4" dark app>
      <v-toolbar flat dark :class="$root.sidebarBg" class="darken-2">
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <img src="img/avatar.jpg" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Administrator</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list class="pt-0" >
        <v-divider></v-divider>       
        <v-list-tile to="/dashboard">
          <v-list-tile-action>
            <v-icon>dashboard</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
         <!-- Promotion -->
        <v-list-tile to="/promotion">
          <v-list-tile-action>
            <v-icon>card_giftcard</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Promotion</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Canvas -->
        <v-list-tile to="/canvas">
          <v-list-tile-action>
            <v-icon>brush</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Canvas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app light class="white elevation-2">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <img class="mt-2" height="60" src="img/logo.png" alt="IronAutomation Inc." />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <!--<img height="30" src="img/peg_slogan.png" alt="PEG" />-->
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        title: 'CNC',
        drawer: true,
        admins: [
          ['Management', 'people_outline'],
          ['Settings', 'settings']
        ],
        cruds: [
          ['Create', 'add'],
          ['Read', 'insert_drive_file'],
          ['Update', 'update'],
          ['Delete', 'delete']
        ],
        types: [
          ['Headings', 'people_outline'],
          ['Sub Heading', 'settings']
        ]
      }
    }
  }
</script>
